import { render } from "./DataCollectionTrigger.vue?vue&type=template&id=459ff075&scoped=true"
import script from "./DataCollectionTrigger.vue?vue&type=script&lang=js"
export * from "./DataCollectionTrigger.vue?vue&type=script&lang=js"

import "./DataCollectionTrigger.vue?vue&type=style&index=0&id=459ff075&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/rb-redev/rb-redev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-459ff075"]])

export default __exports__